module.exports = __webpack_public_path__ + "assets/img/guarantee4.8ada4795.png";